/** Answer engines of the monitor queries */
export enum ViAnswerEngineApiEnum {
    openai = 'openai',
    gemini = 'gemini',
    perplexity = 'perplexity',
    xai = 'xai',
    anthropic = 'anthropic',
}
